<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_223_1213)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.24551 13C4.24551 17.5588 7.94118 21.2545 12.5 21.2545C17.0588 21.2545 20.7545 17.5588 20.7545 13C20.7545 8.44118 17.0588 4.74551 12.5 4.74551C7.94118 4.74551 4.24551 8.44118 4.24551 13ZM12.5 2.99551C6.97468 2.99551 2.49551 7.47468 2.49551 13C2.49551 18.5253 6.97468 23.0045 12.5 23.0045C18.0253 23.0045 22.5045 18.5253 22.5045 13C22.5045 7.47468 18.0253 2.99551 12.5 2.99551Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.25 14.4502L12.7229 9.61628C12.6431 9.4638 12.5698 9.32353 12.5013 9.19371C12.4329 9.32353 12.3595 9.46379 12.2798 9.61626L9.7528 14.4489C9.63619 14.6719 9.52945 14.8764 9.43207 15.0645C9.6274 14.9827 9.83994 14.893 10.0717 14.795L11.0387 14.3861C11.0617 14.3764 11.0875 14.3652 11.1159 14.3528C11.3942 14.2319 11.9178 14.0045 12.4984 14.0043C13.079 14.0042 13.6027 14.2314 13.881 14.3522C13.9094 14.3645 13.9352 14.3757 13.9583 14.3854L14.9312 14.7963C15.1628 14.8942 15.3752 14.9837 15.5704 15.0652C15.4731 14.8774 15.3665 14.673 15.25 14.4502ZM12.5014 6.57382C11.8958 6.5738 11.5069 7.31765 10.729 8.80537L8.20201 13.638C7.12361 15.7004 6.5844 16.7316 7.06122 17.2491C7.53803 17.7665 8.60979 17.3133 10.7533 16.4068L11.7203 15.9979L11.7203 15.9979C12.1042 15.8356 12.2962 15.7544 12.4988 15.7543C12.7014 15.7543 12.8934 15.8354 13.2774 15.9976L14.2503 16.4085C16.3927 17.3133 17.4638 17.7657 17.9404 17.2483C18.417 16.7309 17.8783 15.7004 16.8008 13.6394L14.2737 8.80551C13.4959 7.31773 13.107 6.57385 12.5014 6.57382Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_223_1213">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
